export default "__VITE_ASSET__CZI1wt5w__"